import React from 'react';

const BowlMark = ({ size = 32, title = 'Marque bol', decorative = false }) => {
  const a11y = decorative
    ? { 'aria-hidden': true, focusable: 'false' }
    : { role: 'img', 'aria-label': title };

  return (
    <svg
      className="bowl-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      {...a11y}
    >
      {!decorative && <title>{title}</title>}
      <path
        d="M9.2 9.4c.2-1.6 1-2.6 1.8-2.6"
        fill="none"
        stroke="#ffe4d8"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M15.2 7.6c.15-1.9 1.1-3.1 2-3.1"
        fill="none"
        stroke="#ffe4d8"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M21.2 9.4c.2-1.6 1-2.6 1.8-2.6"
        fill="none"
        stroke="#ffe4d8"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <ellipse cx="16" cy="20.2" rx="11" ry="7.1" fill="#fff8f3" />
      <ellipse cx="16" cy="18.1" rx="8.4" ry="2.55" fill="#ffe8dc" />
      <ellipse cx="16" cy="18.55" rx="6.7" ry="1.7" fill="#fff8f3" />
    </svg>
  );
};

export default BowlMark;
